
export default {
    main: {
        1: [
            "ちょっと声が聞こえにくかったかも……",
            "丁寧にしゃべっていたけど聞こえにくかったかも……",
            "少し他の人に聞こえづらかったかも……",
            "ささやかな声で魅力はありましたが、聞きにくかったかも……",
            "少し恥ずかしかったのか声小さめだったかも……",
        ],
        2: [
            "大きな声だけどちょっと音割れしてたかも……",
            "とても迫力がある声ですが音割れしてたかも……",
            "ものすごく元気で聞く人も驚いていたかも……",
            "良く通る声でしたが音が上手く拾えてなかったかも……",
            "大きな声ですが少し力を抜くと聞き取りやすいかも……",
        ],
        3: [
            "声の大きさもいい感じ！",
            "よく通る声でした！",
            "ちょうどよい音量です！",
            "聞きやすい声の大きさでした！",
            "聞く人に優しい声の大きさでした！",
        ],
        4: [
            "元気な声で素敵でした！",
            "迫力のある声量でした！",
            "聞き手によく伝わる声でした！",
            "はっとさせられる大きな声でした！",
            "言葉がはっきりと聞こえるよい声でした！",
        ],
        5: [
            "良く通る素敵な声でした！",
            "パワフルで魅力的な声でした！",
            "聞き手を引きつける声量でした！",
            "元気がもらえる素敵な声でした！",
            "大迫力な声量でした！",
        ],
    },
    title: {
        1: [
            "慎重なブンチョウ！？",
        ],
        2: [
            "縄張り意識の高いカラス！？",
        ],
        3: [
            "聡明なフクロウ！",
        ],
        4: [
            "最高級のホトトギス！",
        ],
        5: [
            "会議に飛来したタンチョウヅル！",
        ],
    },
    comment: {
        1: [
            "丁寧なかわいらしい声、でもちょっと目立たない？",
        ],
        2: [
            "とってもアピールが上手、でも他の人がびっくりしてる？",
        ],
        3: [
            "最適オブ最適な声、よい塩梅の心地よさ！",
        ],
        4: [
            "良く通る素敵な声で、聞いているこちらがウットリ！",
        ],
        5: [
            "その声に誰もが一目置く、これぞ鶴の一声！",
        ],
    },
}

